import { SurveyQuestions } from "../interface"

export const prepareSurveyQuestions = (
    data: SurveyQuestions | undefined
): SurveyQuestions | undefined => {
    if (!data || data.questions?.length === 0) return
    data.questions.sort((a, b) => a.sequence_number - b.sequence_number)
    data.maxStep = data.questions.reduce(function (counter, value) {
        return counter >= value.step ? counter : value.step
    }, 0)
    return data || []
}
